import loader from "../../../assets/images/loader.gif";

type LoaderProps = {
  loading?: boolean;
};

const PageLoader: React.FC<LoaderProps> = () => {
  return (
    <div
      className="fixed top-0 left-0 w-screen h-screen z-50"
      style={{ background: "rgba(0, 0, 0, 0.7)" }}
    >
      <div className="fixed top-2/4 left-2/4 -ml-10 ">
        <img
          src={loader}
          alt={" "}
          className="top-2/4 left-2/4  w-[80px] h-[80px]"
        />
      </div>
    </div>
  );
};
export default PageLoader;
